import client from "utils/api";
function saveSubscription(data){
  return client().post(`/subscriptions`, data)
    .then((response) => {
      console.log(response);
      return response.data
    }).catch(err=>{console.log("ERR", err); return err.response.data})
}
function checkCoupon(coupon){
  return client().post("/subscriptions/coupons", {coupon}).then(response=>response.data)
}


export default {
  saveSubscription,
  checkCoupon
}



// WEBPACK FOOTER //
// ./src/components/subscriptions/modal/api.js